const getDateFromISOstring = (
    value,
    options = {
        day: '2-digit', month: '2-digit', year: 'numeric', hour12: false
    }) => {
    return value ? Intl.DateTimeFormat('it-IT', options).format(new Date(value)) : value;
}

export default getDateFromISOstring;